// extracted by mini-css-extract-plugin
export var cancelButton = "_na-5";
export var content = "_na-3";
export var createButton = "_na-6";
export var drawerContainer = "_na-0";
export var footer = "_na-2";
export var header = "_na-1";
export var orderFormColumn = "_na-4";